// ** Initial State
const initialState = {
    list:[],
    visbility: null,
    users: null,
    event: null
  }
  
  const event = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_EVENT_LIST':
        return { ...state, list: action.data }
      case 'TOGGLE_EVENT_VISIBILITY':
        return { ...state, visbility: action.data }
      case 'GET_EVENT_USERS_LIST':
        return { ...state, users: action.data }
      case 'CREATE_EVENT':
        return { ...state, event: action.data }
      default:
        return { ...state }
    }
  }
  export default event
  